import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FinalSuccessEventsService {
  private eventSubject = new Subject<string>();
  showWebSiteLink$ = this.eventSubject.asObservable();

  triggerEvent(showWebSiteLink: string) {
    this.eventSubject.next(showWebSiteLink);
  }
}
